import React from 'react';
import { useEditor } from '@craftjs/core';
import {
  Box,
  Chip,
  Grid,
  Typography,
  Button as MaterialButton,
} from '@mui/material';

interface CSelectedNode {
  id: string;
  name: string;
  settings?: any;
  isDeletable: boolean;
}

export const CSettingsPanel: React.FC = () => {
  const { actions, selected, isEnabled } = useEditor((state, query) => {
    const currentNodeId = query.getEvent('selected').last();
    let selectedNode: CSelectedNode | undefined;

    if (currentNodeId) {
      selectedNode = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        settings:
          state.nodes[currentNodeId].related &&
          state.nodes[currentNodeId].related.settings,
        isDeletable: query.node(currentNodeId).isDeletable(),
      };
    }

    return {
      selected: selectedNode,
      isEnabled: state.options.enabled,
    };
  });

  return (isEnabled && selected) ? (
    <Box p={2}>
      <Grid container direction="column" spacing={0}>
        <Grid item>
          <Box pb={2}>
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography variant="subtitle1">Selected</Typography>
              </Grid>
              <Grid item>
                <Chip
                  size="small"
                  color="primary"
                  label={selected.name.replace('C', '')}
                  data-cy="chip-selected"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <div data-cy="settings-panel">
          {selected.settings && React.createElement(selected.settings)}
        </div>
        {selected.isDeletable ? (
          <MaterialButton
            variant="contained"
            color="primary"
            onClick={() => {
              actions.delete(selected.id);
            }}
          >
            Delete
          </MaterialButton>
        ) : null}
      </Grid>
    </Box>
  ) : (
    <Box style={{ position: "relative", height: "100px" }}>
      <Typography style={{ 
        position: "absolute",
        width: "100%",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box",
        color: "#888",
      }}>
        Please select(mouse right click) Elements of left panel to inspect.
      </Typography>
    </Box>
  );
};